module.exports = __webpack_public_path__ + "static/media/football.6334f3cb.png";